export const JaLocale = {
    page: {
        txtTitle: 'Shiritori | しりとりで楽しく覚えるオンライン日本語ボキャブラリーゲーム',
    },
    common: {
        txtLogoAlt: 'カブースの列車',
    },
    header: {
        txtLeave: 'ゲームを退出',
    },
    dialog: {
        leave: {
            txtTitle: 'このゲームを退出しますか？',
            btnStay: 'ゲームに残る',
            btnLeave: '退出して投了する',
        },
    },
    home: {
        btnNewGame: 'ニューゲーム',
        btnMainMenu: 'メインメニュー',
        btnJoinGame: '参加',
        btnReturnToGame: 'ゲームに戻る',
    },
    create: {
        headingNamePrompt: '名前を教えてください',
        placeholderName: 'あなたの名前',
        btnOk: 'OK',
    },
    join: {
        placeholderName: 'あなたの名前',
        placeholderGameId: 'ゲームID',
        btnJoinGame: '参加',
    },
    configure: {
        header: 'ゲーム設定',
        labelExpectedPlayers: 'プレイヤー人数',
        labelBoardSize: 'ボードサイズ',
        labelWordList: '単語リスト',
        labelAllowHints: 'ヒントを許可',
        labelTurnTimer: 'ターンタイマー',
        optionNoTimer: 'タイマーなし',
        optionTimer: 'タイマーあり',
        unitSeconds: '秒',
        btnStartGame: 'スタート',
        toastCreateError: 'エラー：このゲームを作成できませんでした',
        toastTryAgain: 'エラー：後でもう一度お試しください。',
    },
    game: {
        lobby: {
            btnReady: '準備完了',
            txtShareInvite: 'このコードを友達に共有しよう！',
            txtPlayer: 'プレイヤー',
            txtTeam: 'チーム',
        },
        message: {
            noSuchGame: 'このゲームは存在しません',
            txtLoading: '読み込み中...',
            txtCannotJoin: 'ゲームに参加できません',
        },
        gameplay: {
            board: {
                timeoutTitle: '時間',
                timeoutSubtitle: '切れ',
            },
            wordSearch: {
                multipleMatches: '複数の候補が見つかりました！',
                yourTurn: 'あなたの番です',
                placeholder: 'どの言葉を出す？',
                playAction: 'プレイ',
                timerSeconds: '{{seconds}}秒',
                toastNoSuchWord: 'その単語はありません！',
                toastCantPlay: 'その単語は使えません！',
                toastPlayed: '"{{word}}" を出しました',
                toastPlayFailed: '残念、プレイできませんでした！',
                validation: {
                    syllableMismatch: '最初の音がつながっていません',
                    missingLastWord: '前のターンに単語がありません',
                    wordNotInList: '選択したリストにない単語です',
                }
            },
            spectate: {
                waitingOn: '{{player}}を待っています',
                timeLeft: '残り時間: {{seconds}}秒',
            },
            endGame: {
                header: 'ゲーム終了',
                viewResults: '結果を見る',
                statsTotalTime: 'プレイ時間合計',
                statsSquaresFilled: '埋めたマス',
                statsLongestWord: '最長の単語',
                share: '共有する',
                sharing: '共有中...',
                ariaCloseLabel: '終了ダイアログを閉じる',
            }
        },
    },
    footer: {
        linkHowToPlay: '遊び方',
        linkPrivacyPolicy: 'プライバシーポリシー',
        txtAllRightsReserved: 'All Rights Reserved.',
    },
    howToPlay: {
        title: 'Shiritori しりとり (shiritori) の遊び方',
        btnPlayNow: '今すぐ遊ぶ！',
        btnReturnToGame: 'ゲームに戻る:',
        description1: 'b|Shiritori| は、日本語のしりとりをオンラインで友達やひとりで遊べるマルチプレイヤーゲームです。語彙を練習しながら絵カードのボードを作っていきます。',
        description2: 'ゲームを作成または参加して、ボードサイズや背景、イラスト、単語リストを選び、誰かがミスする前にグリッドを埋めるスピードを競います。',
        gameSetup: {
            title: 'ゲームの作成・参加',
            p1: 'ひとりで遊ぶか、リンクやゲームコードを共有して最大9人の友達（合計10人）を招待できます。',
            p2: 'ボードサイズ（3x3、5x5、7x7）、背景のパターン/色、イラストセット、練習したい単語リストを選びます。',
            p3: '友達はリンクを開いてニックネームを入力するとロビーに表示されます。予定人数が揃ったらゲーム開始。',
            p4: '途中参加も観戦モードで進行中の試合を見られます。',
        },
        objective: {
            title: '目的',
            p1: '前の単語の最後の音から始まる言葉をつなげてボードを埋め、最後を「ん」で終わらせないこと。',
        },
        wordRules: {
            title: '有効な単語',
            p1: 'かなまたはローマ字で入力できます。ローマ字は送信前にクライアント側でひらがなに変換されます。',
            p2: '選択したリスト（100/1000 基本語、食べ物、スポーツなど）に含まれる単語だけ使用でき、プレイ後に意味が表示されます。',
            p3: '使用済みの単語はブロックされます。ホモフォンを許可している場合は、正しい絵が付いた未使用のバリエーションを選べます。',
            li1: '前のターンの指定音で始まる',
            li2: '「ん」で終わらない',
            li3: '選択したリストに含まれている',
            li4: 'この試合でまだ使われていない',
            li5: 'ホモフォン/画像のルールが有効なときは許可されたものを使う',
            p4: '有効なプレイごとに絵が順番にボードへ落ち、左上から右下に向かって埋まっていきます。 e|例:_そば_→_バス|',
        },
        turnFlow: {
            title: 'ターンと時間',
            p1: 'ターンはプレイヤー順に回ります。自分の番が見えた瞬間から最大10秒与えられます。',
            p2: 'Shiritori は次のプレイヤーの画面がアクティブになるまでカウントを開始しないので、リロードしてもタイマー飛ばしはできません。',
            p3: '単語を入力するとリアルタイムでチェックが入り、締切までに送信してください。無効または遅延の送信は即終了となります。',
        },
        boardFlow: {
            title: 'ボードと進行、終了',
            p1: 'ボードには各単語と絵、プレイヤー名、ターン番号が表示され、矢印で順番が追えます。',
            p2: '自分の番でなくても、次に必要な頭文字と残り時間が見えます。',
            p3: 'すべてのマスが有効な単語で埋まれば成功。完成したボードを共有できます。',
            p4: '制限時間までに有効な手が出なければ、時間切れや無効ワードを出したプレイヤーのサマリーとともに終了します。',
        },
        summary: {
            title: 'まとめ',
            p1: 'Shiritori は短いラウンドとわかりやすいルール、絵による記憶を使って、しりとりをテンポよくビジュアルに楽しめます。',
            p2: 'リンクをシェアしてボードを埋め、どこまでチェーンを伸ばせるか挑戦しよう。',
        }
    },
    bugsAndFeatures: {
        title: 'バグ報告と新機能の提案',
        p1: 'このゲームはクラシックな k|しりとり| を別の形で遊ぶために作りました。ゲーム好きのチームとして、より楽しくできる改善を常に探しています。',
        cta: {
            l1: 'ぜひ',
            a: '友達にシェアして',
            l2: 'SNSで広めてください！'
        },
        p2: 'バグを見つけたり新しいアイデアがあればぜひ教えてください！',
        bugs: {
            title: 'バグ',
            p1: '奇妙な動作やエラーを見つけたら、a|https://github.com/indexinteractive/|GitHubリポジトリ| で報告してください。再現手順などできるだけ詳しく書いてもらえると助かります。'
        },
        features: {
            title: '新機能',
            p1: '新しい機能や改善の提案があれば、a|https://github.com/indexinteractive/|GitHubのディスカッション| で新しいスレッドを立ててください。'
        }
    },
    share: {
        title: 'Shiritori | しりとりで楽しく覚えるオンライン日本語ボキャブラリーゲーム',
        text: '友達や他のプレイヤーとオンラインでしりとりをプレイ。登録不要で遊べます！',
    }
};
